---
title: Built to Thrive in the World of AI
slug: built-to-thrive-gpt
type: gpt
status: published
featured: true
summary: Book companion GPT for Built to Thrive — megawaves of change, how AI shapes the future, and how humans should respond.
sitePublishedAt: "2026-09-18"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - computational-social-science
  - innovation-systems
sourceUrl: https://chatgpt.com/g/g-ZS1LEEzIv-built-to-thrive-in-the-world-of-ai
originalAuthor: Jay van Zyl
sourceRelationship: first-party Custom GPT authored by Jay van Zyl
rightsStatus: first-party
seoDescription: Built to Thrive in the World of AI is Jay van Zyl’s Custom GPT companion to the 2011 book.
canonicalPath: /work/gpts
storeId: g-ZS1LEEzIv
kind: book-companion
---

A ChatGPT GPT authored as Jay van Zyl. Starter prompts on the store: What are the megawaves of change? How will AI shape our future? Will the role of innovation change over time? How should humans respond to the changes?

Use it next to the book, not as a substitute for it.
